import { useMutation } from '@tanstack/react-query'

import type { RepublishResourceRequestAndResponse } from '@/features/resource/endpoints/resources'
import { republishResource } from '@/features/resource/endpoints/resources'

export function useRepublishResourceMutation() {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (params: { resourceId: string; request: RepublishResourceRequestAndResponse }) =>
      republishResource(params.resourceId, params.request),
  })

  return {
    republishResource: mutateAsync,
    ...mutationResult,
  }
}
